/*
 * Instalación de la app (botón "Descargar app" de la landing).
 *
 * Chrome/Edge/Android disparan "beforeinstallprompt" cuando la app se puede
 * instalar: se guarda el evento para mostrar el diálogo de instalación al
 * tocar el botón. Safari (iPhone/iPad) no lo soporta: ahí se instala desde
 * Compartir → "Agregar a inicio".
 */

let eventoInstalacion = null;
const suscriptores = new Set();

const notificar = () => suscriptores.forEach((fn) => fn());

export const suscribirInstalacion = (fn) => {
    suscriptores.add(fn);
    return () => suscriptores.delete(fn);
};

// Se llama una sola vez al iniciar la app: el evento puede llegar antes de que se monte la landing
export const iniciarCapturaInstalacion = () => {
    window.addEventListener('beforeinstallprompt', (evento) => {
        evento.preventDefault();
        eventoInstalacion = evento;
        notificar();
    });

    window.addEventListener('appinstalled', () => {
        eventoInstalacion = null;
        notificar();
    });
};

export const puedeInstalarseDirecto = () => Boolean(eventoInstalacion);

// Ya se está usando como app instalada (no en una pestaña del navegador)
export const esAppInstalada = () =>
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const esIOS = () =>
    /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

// Muestra el diálogo nativo de instalación. Devuelve true si el usuario aceptó
export const instalarApp = async () => {
    if (!eventoInstalacion) return false;
    eventoInstalacion.prompt();
    const { outcome } = await eventoInstalacion.userChoice;
    eventoInstalacion = null;
    notificar();
    return outcome === 'accepted';
};
